/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components';

interface buttonProps {
  color: string;
  padding: string;
}

interface dropdownProps {
  active: boolean;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const ButtonContainer = styled.button<buttonProps>`
  font-family: 'Source Sans Pro' sans-serif;
  font-size: 1rem;
  font-weight: 400;
  height: 40px;
  padding: 0 3rem;
  padding: ${props => `0 ${props.padding}rem`};
  background: ${props => `var(--${props.color})`};
  border-radius: 6px;
  border: 0;
  transition: background 0.2s;
  color: var(--white);
`;

export const DropdownContainer = styled.div<dropdownProps>`
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  position: absolute;
  top: 40px;
  width: 100%;
  z-index: 999999;
  background: var(--white);
  display: none;

  button {
    font-size: 15px;
    height: 40px;
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;

    color: var(--title-higlight);
    background: var(--white);
    cursor: pointer;

    &:hover {
      background: #dadada;
    }

    & > svg {
      margin-top: 4px !important;
      margin-left: 5px !important;
    }
  }

  ${props =>
    props.active &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;
